<template>
<div>
    <md-dialog
      :md-active.sync="show"
      @md-clicked-outside="closeDialog"
      @md-closed="closeDialog"
    >
        <md-dialog-title>Add new Application</md-dialog-title>
      <div
        class="md-dialog-content md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      >
            <form>
          <md-field
            class="md-layout-item md-small-size-100 md-size-100 "
            :class="ApplicationNameClass"
          >
                    <label>Application name</label>
                    <md-input v-model="newAppName" required></md-input>
                    <span class="md-error">Application name is required</span>
                </md-field>
                <md-field :class="ApplicationDescriptionClass">
                    <label>Application description</label>
                    <md-textarea v-model="newAppDescription" required></md-textarea>
                    <span class="md-error">Application description is required</span>
                </md-field>
            </form>
            <div class="md-layout-item md-size-100 text-right">
                <md-button @click="closeDialog">Close</md-button>
                <md-button class="md-primary" @click="createNewApp">Add</md-button>
            </div>
        </div>
    </md-dialog>

    <md-dialog :md-active.sync="showApiKey" class="warning-dialog">
        <md-dialog-title>
            <md-icon>warning</md-icon>
            API-Key
        </md-dialog-title>
        <div class="md-dialog-content">
            <div class="md-subheading warning-text">
                This API-Key will be used for authentication purposes. For security
                reasons, this is the last time the API-Key is shown. It will not be
                accessible in the future. Please store it securely.
            </div>
            <div class="api-key">
                <div class="key">
                    <small class="holder">{{ apiKey }}</small>
                </div>
                <md-button class="btn" @click="copyApiKey">
                    <md-icon>file_copy</md-icon>
                    Copy to clipboard
                </md-button>

                <!--                    <div class="size-test"> <code class="holder">{{api_key}}</code> </div>-->
            </div>
            <div dir="rtl">
          <md-button class="md-primary md-raised" @click="appDetails"
            >OK</md-button
          >
            </div>
        </div>
    </md-dialog>
</div>
</template>

<script>
import fetchErrorHandler from "../error";

export default {
    name: "CreateNewApplication",
    props: ["show"],
    data() {
        return {
            showApiKey: false,
            applicationID: null,
            hasApplicationNameClass: false,
            hasApplicationDescriptionClass: false,
            newAppName: "",
            newAppDescription: "",
            apiKey: ""
        };
    },
    computed: {
        ApplicationNameClass() {
            return {
                "md-invalid": this.hasApplicationNameClass
            };
        },
        ApplicationDescriptionClass() {
            return {
                "md-invalid": this.hasApplicationDescriptionClass
            };
        }
    },
    methods: {
    createNewApp: function() {
            if (this.newAppName === "") {
                this.hasApplicationNameClass = true;
                return;
            }
            if (!this.newAppDescription) {
                this.hasApplicationDescriptionClass = true;
                return;
            }
            let url =
                this.$store.state.server_address +
                "api/v1/dashboard/create-application/";
            let data = {
                application_name: this.newAppName,
                application_description: this.newAppDescription
            };
            let headers = {
                "Content-Type": "application/json",
                Authorization: this.$store.getters.getAccessToken
            };

            fetch(url, {
                    method: "POST",
                    headers: headers,
                    body: JSON.stringify(data)
                })
                .then(response => {
                    if (response.status !== 200) {
                        return response.json().then(data => {
                            response.data = data;
                            return response;
                        });
                    }
                    return response;
                })
                .then(response => {
                    if (response.status !== 200) {
                        const responseCode = response.data?.code;

                        if (responseCode === 40003) {
                          this.notifyVue("top", "right", response.data.message_detail, "danger");
                        }

                        fetchErrorHandler(
                            response.status,
                            response.statusText,
                            this.$options.name
                        );
                    } else
                        response
                        .json()
                        .then(json_response => {
                            this.$emit("close");
                            this.showApiKey = true;
                            this.apiKey = json_response.response.api_key;
                            this.applicationID = json_response.response.application_pk;
                            this.newAppDescription = "";
                            this.newAppName = "";
                        })
              .catch(/* */);
                })
                .catch();
        },
    closeDialog: function() {
            this.newAppDescription = "";
            this.newAppName = "";
            this.$emit("close");
        },
    appDetails: function() {
            this.$router.push(
                "/application-management/applications/application-details/?application_id=" +
                this.applicationID
            );
        },
    copyApiKey: function() {
            let that = this;
            navigator.clipboard
                .writeText(this.apiKey)
        .then(function() {
                    that.notifyVue("top", "right", "Successfully copied! ");
                })
        .catch(/* */);
        },
        notifyVue: function (verticalAlign, horizontalAlign, message, type="success") {
            this.$notify({
                message: message,
                icon: "add_alert",
                horizontalAlign: horizontalAlign,
                verticalAlign: verticalAlign,
                type: type
            });
        }
    }
};
</script>

<style scoped lang="scss">
.api-key {
    margin: 32px 0 16px 0;

    .btn {
        text-transform: none;
        margin-top: 8px;
        margin-left: 0;
        font-size: x-small;
        /*.md-ripple{*/
        /*    padding: 0px;*/
        /*}*/
        .md-icon {
            font-size: 16px !important;
        }
    }

    .holder {
        text-align: center;
        display: inline-block;
        width: 100%;
        padding: 8px 8px;
        border-style: solid;
        border-color: gray;
        border-width: 1px;
        background-color: gainsboro;
        border-radius: 4px;
        overflow-x: auto;
    }
}

.size-test {
    width: 100%;
}

.api-key .md-ripple {
    padding: 0 !important;
}
</style>
